import React from 'react';

import type { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import type { BlockBackgroundImage } from '../../../types/uncinc_profile/blocks';
import { VariableRatiosPicture } from '../../../components';

export interface CtaBlockProps {
  entity: ImmutableEntity<BlockBackgroundImage>;
}

const BackgroundImage: React.FC<CtaBlockProps> = ({
  entity,
}) => {
  const block = entity.toJS();
  const image = block.field_media[0];

  return (
    <div className="Block BlockBackgroundImage">
      <VariableRatiosPicture
        image={image}
        aspectRatios={['3_4', '3_4', '1_1', '3_2', '16_9']}
      />
    </div>
  );
};

export default BackgroundImage;
